import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from "reactstrap";

const statusLabel = (item) => {
  if (item.status === "success") {
    return "Success";
  }
  if (item.status === "failed") {
    return item.message || "Failed to fetch";
  }
  if (item.status === "syncing") {
    return "Syncing…";
  }
  return "Pending";
};

const SyncMissingInfoModal = ({
  isOpen,
  toggle,
  items = [],
  isSyncing = false,
  onSync,
}) => {
  const pendingCount = items.filter(
    (item) => item.status !== "success",
  ).length;
  const successCount = items.filter((item) => item.status === "success").length;
  const failedCount = items.filter((item) => item.status === "failed").length;

  return (
    <Modal
      isOpen={isOpen}
      toggle={isSyncing ? undefined : toggle}
      size="lg"
      className="sync-missing-info-modal"
      contentClassName="sync-missing-info-modal__content"
    >
      <ModalHeader className="sync-missing-info-modal__header" toggle={toggle}>
        Sync Missing Info
      </ModalHeader>
      <ModalBody>
        <p className="text-muted mb-3">
          Suggested parts that still have N/A Country of Origin. DigiKey details
          are fetched in the background and saved so they populate next time.
          Sync starts automatically when parts are added.
        </p>
        {!items.length ? (
          <p className="mb-0">No selected unmatched parts are missing Country of Origin.</p>
        ) : (
          <Table className="table-bordered table-sm mb-0 sync-missing-info-table">
            <thead>
              <tr>
                <th>Part Number</th>
                <th>Manufacturer</th>
                <th style={{ width: "28%" }}>Progress</th>
                <th style={{ width: "22%" }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.key} className={`sync-missing-row is-${item.status}`}>
                  <td>
                    <strong>{item.mpn}</strong>
                    {item.originalMpn ? (
                      <div className="text-muted small">
                        Replaces {item.originalMpn}
                      </div>
                    ) : null}
                  </td>
                  <td>{item.manufacturer || "N/A"}</td>
                  <td>
                    <div
                      className="sync-missing-progress"
                      role="progressbar"
                      aria-valuemin={0}
                      aria-valuemax={100}
                      aria-valuenow={item.progress || 0}
                    >
                      <div
                        className={`sync-missing-progress__bar is-${item.status}`}
                        style={{ width: `${item.progress || 0}%` }}
                      />
                    </div>
                    <div className="sync-missing-progress__label">
                      {item.progress || 0}%
                    </div>
                  </td>
                  <td>
                    <span className={`sync-missing-status is-${item.status}`}>
                      {statusLabel(item)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {items.length > 0 ? (
          <div className="small text-muted mt-3">
            {successCount} success
            {failedCount > 0 ? ` · ${failedCount} failed to fetch` : ""}
            {pendingCount > 0 && !isSyncing
              ? ` · ${pendingCount} remaining`
              : ""}
          </div>
        ) : null}
      </ModalBody>
      <ModalFooter className="sync-missing-info-modal__footer">
        <Button
          type="button"
          color="secondary"
          onClick={toggle}
        >
          {isSyncing ? "Hide" : "Close"}
        </Button>
        <Button
          type="button"
          color="primary"
          disabled={isSyncing || pendingCount === 0}
          onClick={onSync}
        >
          {isSyncing ? "Syncing…" : failedCount > 0 ? "Retry failed" : "Sync"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SyncMissingInfoModal;
